AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Base");

AoPS.Ebooks.Views.Base = (function (EbkVBase) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var BbExtras = AoPS.BackboneExtras;
	var Ui = AoPS.Ui;
	var Modal = AoPS.Ui.Modal;
	var LoadUtils = AoPS.LoadUtils;
	var EbkUrlMain = AoPS.Ebooks.Url.main;

	// Allow EbkUrlMain in Handlebars templates
	Handlebars.registerHelper("ebkurl", _.bind(EbkUrlMain.getUrl, EbkUrlMain));

	EbkVBase.getErrorFooter = function (data) {
		// Some revisions made near launch after folding some of this advice into
		// our standard error messages.
		if (data.error_code === "E_UNREGISTERED") {
			return (
				"Please either sign in or register a new account with our " +
				"website by using the links in the top right. " +
				"Your account will need to have permission to view our online books " +
				"before you can continue using this page."
			);
		} else if (data.error_code === "E_NO_AUTH") {
			return "Please sign back in using the links in the top right before continuing.";
		} else {
			return ""; //'Please try again later. If problems continue, contact ' +
			// 'Art of Problem Solving and report what you are trying to do and ' +
			// 'what problems you are experiencing.';
		}
	};

	// Show a hard-coded error message if appropriate. Return truey if a
	// message was shown and falsy if the standard handler should show a message.
	EbkVBase.showSpecialError = function (data, modal_params) {
		var error_code = data.error_code;

		if (error_code === "E_UNREGISTERED") {
			Ui.buildLoginConfirm(
				"In order to use Ebooks, " +
					"you must be signed into an account that has obtained access to our online books. " +
					"If you are one of our online book customers, please sign in.",
				modal_params
			);
		} else if (data.error_code === "E_NOT_INITIALIZED") {
			AoPS.Initialize.display();
			// } else if (error_code === 'E_SESSION_ENDED') {
			// 	Modal.closeAllModals();
			// 	Ui.buildLoginConfirm('Regrettably, your login session on our site ' +
			// 		'has expired, so we were unable to process your last action. Please ' +
			// 		'use the button below to sign back in, then retry what you just did.', modal_params);
		} else {
			// Nothing special done
			return false;
		}
		return true;
	};

	EbkVBase.showModalError = function (base, data, modal_params) {
		modal_params = modal_params || {};
		var showed_spec_error = EbkVBase.showSpecialError(data, modal_params);
		if (showed_spec_error) {
			return;
		}

		base = base ? base + " " : "";

		var data_error = data.error_msg;
		data_error = data_error ? data_error + " " : "";

		var footer = EbkVBase.getErrorFooter(data);

		Modal.showAlert(base + data_error + footer, modal_params);
	};

	EbkVBase.showFreePreviewModal = function (tpl_id, book_model) {
		var baseTpl = compileTemplate("#ebk-cms-preview-base");
		var specTpl = compileTemplate("#ebk-cms-" + tpl_id);
		Modal.showAlert(
			"<p>" +
				specTpl() +
				"</p>\n" +
				"<p>" +
				baseTpl({store_sku: book_model.get("store_sku")}) +
				"</p>"
		);
	};

	var base_view = _.extend({}, BbExtras.TemplateMixin, BbExtras.SubviewMixin, {
		// Called before any template rendering and subview injection.
		// No-op by default; override in derived classes
		preRender: function () {},

		// Return the context for the Handlebars template.
		getContext: function () {
			// Override in derived classes
			return {};
		},

		// If you have code that needs to wait for a view to render before
		// executing, wrap that code in a callback and send it to this
		// function.
		whenRendered: function (callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			if (this.rendered) {
				setTimeout(callback, 0);
			} else {
				this.render_callbacks = this.render_callbacks || [];
				this.render_callbacks.push(callback);
			}
		},

		// Internal function for managing render callbacks.
		setRendered: function (new_val) {
			this.rendered = !!new_val;
			if (new_val && this.render_callbacks && this.render_callbacks.length) {
				setTimeout(
					_.bind(function () {
						_.each(this.render_callbacks, function (cb) {
							cb();
						});
						this.render_callbacks = [];
					}, this),
					0
				);
			}
		},

		// The standard rendering procedure, handling subviews and templates.
		// Do not override this in derived classes; override preRender or
		// postRender to inject appropriate behavior.
		render: function () {
			// Do not override
			this.preRender();
			this.detachAllSubviews();
			this.renderTemplate(this.getContext());
			this.attachAllSubviews();
			this.removeHandlebarsLocationMarkers();
			this.postRender();
			this.setRendered(true);
		},

		// An alternative to render, when the element should simply display a
		// piece of given HTML.
		renderSimple: function (html) {
			this.detachAllSubviews();
			this.renderTopOnly();
			this.$el.html(html || "");
			this.setRendered(true);
		},

		// An alternative to render, when the element is not ready and should
		// display a loading indicator. Optionally, provide HTML for the loader;
		// otherwise a suitable default is used.
		renderLoading: function (loader) {
			this.renderSimple();
			loader = _.isUndefined(loader) ? AoPS.Page.$loader.clone() : loader;
			this.$el.append(loader || "");
			this.setRendered(false);
		},

		// An alternative to render, when the element can't be displayed and
		// should throw an error panel up. Provide the error data..
		renderError: function (data) {
			if (_.contains(["E_UNREGISTERED", "E_SESSION_ENDED"], data.error_code)) {
				// Need to show the login dialog here
				EbkVBase.showSpecialError(data);
				this.renderSimple(this.getErrorBox(data));
			} else {
				this.renderSimple(this.getErrorBox(data));
			}
			this.setRendered(false);
		},

		getErrorBox: function (data) {
			var error_msg = data && data.error_msg;
			var errorBoxTpl = compileTemplate("#ebk-tpl-error-box");

			return errorBoxTpl({
				error_msg: error_msg || "",
				footer: data.footer || EbkVBase.getErrorFooter(data),
			});
		},

		// Called after any template rendering and subview injection.
		// No-op by default; override in derived classes
		postRender: function () {},

		// Default behavior for closing this view. If overridden, make sure to
		// call these methods too.
		onClose: function () {
			this.stopListening();
			this.closeAllSubviews();
		},
	});
	EbkVBase.BaseView = Backbone.View.extend(base_view);

	// AoPS Font helper
	EbkVBase.makeAopsFontText = function (text) {
		return '<span class="aops-font">' + text + "</span>";
	};

	// Enable or disable hrefs. Disabling means replacing href with a
	// data attribute, enabling means restoring it.
	EbkVBase.enableHrefs = function ($el, enabled) {
		var from_attr = enabled ? "data-offline-href" : "href";
		var to_attr = enabled ? "href" : "data-offline-href";
		$el = $el || $("body");

		$el.find("a[" + from_attr + "]").each(function () {
			var $a = $(this);
			$a.attr(to_attr, $a.attr(from_attr));
			$a.removeAttr(from_attr);
		});
	};

	EbkVBase.Placeholder = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-placeholder");

			this.classes = options.classes || [];

			this.render();
		},

		postRender: function () {
			this.$el.addClass(this.classes.join(" "));
		},
	});

	EbkVBase.CopyTextModal = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-copy-text-modal");

			this.description = options.description;
			this.text = options.text;

			this.render();
		},

		getContext: function () {
			return {
				description: this.description,
				text: this.text,
			};
		},

		show: function () {
			this.$el.showModal();
			setTimeout(function () {
				this.$("input").select();
			}, 0);
		},
	});

	return EbkVBase;
})(AoPS.Ebooks.Views.Base);
